import { createReducer, on } from '@ngrx/store';
import { WebhookActions } from './webhook.actions';
import { Webhook } from '../../../shared/interfaces/webhook.interfaces';

export const webhookFeatureKey = 'webhook';

export interface WebhookState {
  webhooks?: Webhook[] | null;
  testResponse?: any | undefined;
}

export const initialState: WebhookState = {
};

export const webhookReducer = createReducer(
  initialState,

  on(WebhookActions.loadWebhooksSuccess, (state, action) => { return { ...state, webhooks: action.data } }),

  on(WebhookActions.testWebhookSuccess, (state, action) => { return { ...state, testResponse: action.data } }),

  on(WebhookActions.resetTest, (state) => { return { ...state, testResponse: undefined} }),

  on(WebhookActions.unsetWebhookStore, () => initialState),

);
